<template>
  <div class="vertical-card" v-if="asset">
    <router-link :to="asset.url">
      <img :src="asset.thumbnail" :alt="asset.title" :title="asset.title" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "VerticalCardSearch",
  props: {
    hit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    asset() {
      let hit = this.hit;
      hit.url = this.url(this.hit);
      return hit;
    },
  },
  methods: {
    url(asset) {
      let url = this.$t("movie_route", { slug: asset.slug });
      if (asset.type === "series") {
        url = this.$t("serie_route", { slug: asset.slug });
      }
      return url;
    },
  },
};
</script>
<style lang="scss">
.vertical-card {
  img {
    border-radius: 16px;
    border: 2px solid rgba(255, 255, 255, 0);
    transition: all 0.3s ease-in-out;
    transform: scale(0.95);
  }
  &:hover {
    img {
      transform: scale(1);
      border: 2px solid white;
      transition: all 0.3s ease-in-out;
    }
  }
}
</style>
